export const ru = {
  header: {
    logoAlt: "Логотип Artem Khloptsev",
    languageSwitcher: "Переключатель языка",
    menuLabel: "Открыть меню",
    nav: {
      home: "Главная",
      projects: "Проекты",
      about: "Обо мне",
      resume: "Резюме",
      contact: "Контакты",
    },
  },
  home: {
    heroAlt: "Главный баннер",
    titleLine: "Я пишу код и",
    titleAccent: "изучаю его!",
    subtitle:
      "Frontend-разработчик с уверенными знаниями HTML5, CSS3, JavaScript (ES6+) и React. Создаю масштабируемые компонентные интерфейсы, работаю с REST API и Supabase для backend-интеграций. Имею базу в backend-разработке и ООП, а также практический опыт разработки Java-приложений. Фокусируюсь на чистой архитектуре, производительности и качественном пользовательском опыте.",
    primaryAction: "Связаться",
    secondaryAction: "Посмотреть CV",
    experienceTitle: "ОПЫТ С",
  },
  resume: {
    title: "Резюме",
    subtitle: "Опыт, образование и технические навыки в удобном веб-просмотре.",
    downloadAction: "Скачать PDF",
    openAction: "Открыть в новой вкладке",
    viewerTitle: "Резюме Артема Хлопцева",
    fallback:
      "Ваш браузер не может показать PDF на этой странице. Откройте его в новой вкладке или скачайте файл.",
  },
  footer: {
    role: "Frontend-разработчик • студент Software Engineering",
    rights: "Все права защищены.",
  },
  about: {
    title: "Обо мне",
    subtitle:
      "Frontend-разработчик • студент Astana IT University • волейболист",
    techTitle: "Технологии",
    experience: {
      title: "Опыт работы",
      subtitle: "Стажировка во frontend-разработке",
      role: "Frontend-разработчик — стажёр",
      company: "Park Technologies",
      period: "Май 2026 — 30 июня 2026",
      location: "Казахстан",
      achievements: [
        "Разрабатывал адаптивные landing page и продуктовые интерфейсы на React, TypeScript, HTML и CSS.",
        "Создавал переиспользуемые UI-компоненты и улучшал производительность на desktop и mobile.",
        "Интегрировал REST API и доводил поддерживаемые интерфейсы от идеи до production.",
        "Проверял кроссбраузерность, доступность и корректное адаптивное поведение.",
      ],
    },
    techCards: [
      {
        title: "Frontend",
        text: "HTML5 • CSS3 • JavaScript (ES6+) • React • адаптивная верстка",
      },
      {
        title: "UI / Стили",
        text: "CSS Grid • Flexbox • анимации • Glassmorphism UI • современные макеты",
      },
      {
        title: "Инструменты",
        text: "Git • GitHub • Figma • VS Code • npm",
      },
      {
        title: "Другое",
        text: "REST API • компонентная архитектура • оптимизация производительности",
      },
    ],
    rows: {
      frontend: {
        alt: "Разработчик",
        title: "Frontend-разработка",
        text: "Я создаю адаптивные интерфейсы на React и современных UI-принципах. Пишу чистый код, структурирую компоненты и делаю готовую к продакшену верстку.",
      },
      volleyball: {
        alt: "Волейбол",
        title: "Волейбол",
        text: "Соревновательный настрой, дисциплина и командная работа. Спорт помогает мне сохранять фокус и стабильный результат.",
      },
      hackathons: {
        alt: "Хакатон",
        title: "Хакатоны",
        text: "Участвовал в startup-соревнованиях и выиграл один из последних баттлов. Быстро проверяю идеи и довожу решения до результата.",
      },
      startup: {
        alt: "Награда",
        title: "Победитель Startup Battle",
        text: "Признание за продуктовое мышление и реализацию. Фокус на реальной пользе, сильной идее и масштабируемости.",
      },
      university: {
        alt: "Кампус Astana IT University",
        title: "Astana IT University",
        text: "Я учусь на Software Engineering в Astana IT University, одной из сильных IT-программ Казахстана. Программа дает хорошую базу по алгоритмам, структурам данных, базам данных и современным практикам разработки.",
      },
    },
  },
  projects: {
    title: "Мои проекты",
    goToPage: "Открыть сайт",
    viewDetails: "Подробнее о проекте",
    imageAlt: "скриншот проекта",
    detail: {
      backToProjects: "Назад к проектам",
      liveDemo: "Открыть демо",
      sourceCode: "Профиль GitHub",
      roleTitle: "Моя роль",
      stackTitle: "Стек технологий",
      overviewTitle: "О проекте",
      challengeTitle: "Задача",
      approachTitle: "Подход",
      resultTitle: "Результат",
      galleryTitle: "Галерея интерфейса",
      notFoundTitle: "Проект не найден",
      notFoundText: "Такого проекта нет или его адрес был изменён.",
      byCategory: {
        real: {
          role: "Frontend-разработка, архитектура интерфейса, адаптивная реализация",
          challenge: "Превратить реальную продуктовую идею в понятный интерфейс, который стабильно работает на разных устройствах и расширяется без дублирования UI-кода.",
          approach: "Я разделил интерфейс на переиспользуемые компоненты, задал предсказуемые правила вёрстки и уделил внимание состояниям, навигации и производительности.",
          result: "Готовый к развитию адаптивный интерфейс с последовательной компонентной структурой и понятной архитектурой.",
        },
        fun: {
          role: "Frontend-разработка, реализация UI, проектирование взаимодействий",
          challenge: "Создать компактный проект, который демонстрирует один полезный сценарий без лишней сложности.",
          approach: "Я сфокусировался на небольшой компонентной модели, понятных переходах состояния, адаптивной вёрстке и быстрой обратной связи.",
          result: "Рабочий сфокусированный продукт, который показывает практические frontend-навыки и готов к расширению.",
        },
        games: {
          role: "Игровая логика, разработка интерфейса, адаптивное взаимодействие",
          challenge: "Сохранить предсказуемое игровое состояние и сделать управление понятным на разных размерах экрана.",
          approach: "Я отделил игровые правила от визуального состояния, явно реализовал победу и перезапуск и сохранил интерфейс лёгким.",
          result: "Играбельная браузерная игра с понятными состояниями, адаптивным управлением и поддерживаемой логикой.",
        },
      },
    },
    filters: {
      all: "Все",
      real: "Реальные проекты",
      fun: "Для практики",
      games: "Онлайн-игры",
    },
    items: {
      goleador: {
        title: "Goleador — коммерческий футбольный магазин",
        description: [
          "Goleador — коммерческий онлайн-магазин профессиональной футбольной формы и спортивного оборудования. Платформа показывает коллекции Kelme и качественную экипировку для команд и игроков.",
          "⚽ Официальная футбольная форма и тренировочная одежда.\n🧤 Профессиональная экипировка и аксессуары.\n🛒 Современный адаптивный e-commerce интерфейс.",
          "Сайт сделан с чистой структурой, понятной подачей товаров и удобной навигацией для комфортного просмотра на разных устройствах.",
        ],
      },
      autoscout: {
        title: "AutoScout — приложение для мониторинга авто",
        description: [
          "AutoScout — веб-приложение для мониторинга автомобилей, где пользователь может отслеживать и управлять выбранными машинами. Интерфейс помогает просматривать объявления, сохранять интересные варианты и работать с данными авто.",
        ],
      },
      gsc: {
        title: "Golden Students Club — startup-платформа",
        description: [
          "Golden Students Club — мой startup-проект для амбициозных студентов. Он помогает находить проверенные возможности: стипендии, стажировки, события и комьюнити для роста.",
          "🏆 С этим проектом я выиграл startup battle, где участвовали 5 стран и 120 команд.\n🚀 Идея продукта + UI/UX + подход к реализации.\n📌 Сделано как современный адаптивный веб-интерфейс.",
        ],
      },
      landing: {
        title: "Короткий landing",
        description: [
          "Pet-проект для практики и демонстрации навыка создавать landing page.",
        ],
      },
      hangman: {
        title: "Мини-игра (Виселица)",
        description: ["Небольшая мини-игра Hangman / “Виселица”."],
      },
      tictactoe: {
        title: "Крестики-нолики",
        description: ["Классическая мини-игра крестики-нолики."],
      },
      birthday: {
        title: "Сайт ко дню рождения",
        description: ["Простой сайт, сделанный ко дню рождения."],
      },
      todo: {
        title: "To-do сайт :0",
        description: ["Минималистичный планировщик задач на день."],
      },
      pomodoro: {
        title: "Таймер Pomodoro",
        description: [
          "Помогает держать фокус, бороться с прокрастинацией и работать умнее.",
          "⚡ 25-минутные спринты • 🌿 5-минутные перерывы • 💡 длинный перерыв после 4 раундов",
        ],
      },
      monkey: {
        title: "Monkey Bouncer Game",
        description: [
          "Простая canvas-игра, где персонаж прыгает по платформам и собирает очки. Используй стрелки влево/вправо или A/D для движения и пробел для прыжка. Цель — набрать как можно больше очков.",
        ],
      },
    },
  },
  contact: {
    title: "Давайте поработаем вместе",
    subtitle: "Расскажите о продукте, сайте или frontend-задаче. Я отвечу на указанную почту.",
    nameLabel: "Ваше имя",
    emailLabel: "Email",
    messageLabel: "Описание задачи",
    submitAction: "Отправить сообщение",
    submittingAction: "Отправляем...",
    errorText: "Не удалось отправить форму. Попробуйте ещё раз или напишите напрямую:",
    privacyNote: "Форма безопасно обрабатывается через Netlify Forms.",
    successTitle: "Сообщение отправлено",
    successText: "Спасибо. Я получил сообщение и отвечу вам в ближайшее время.",
    backHome: "Вернуться на главную",
  },
  notFound: {
    eyebrow: "Ошибка навигации",
    title: "Эта страница потерялась в коде",
    text: "Возможно, ссылка устарела или в адресе есть ошибка. Выберите один из доступных маршрутов.",
    homeAction: "На главную",
    projectsAction: "Посмотреть проекты",
    contactAction: "Связаться со мной",
  },
  seo: {
    home: {
      title: "Artem Khloptsev — Frontend-разработчик",
      description: "Портфолио frontend-разработчика: React, TypeScript, Chakra UI, адаптивные интерфейсы и продуктовые проекты.",
    },
    projects: {
      title: "Проекты — Artem Khloptsev",
      description: "Frontend-кейсы, коммерческие интерфейсы, веб-приложения и интерактивные браузерные проекты.",
    },
    about: {
      title: "Обо мне — Artem Khloptsev",
      description: "Опыт, технологии, образование и профессиональный путь frontend-разработчика Artem Khloptsev.",
    },
    resume: {
      title: "Резюме — Artem Khloptsev",
      description: "Просмотр и скачивание резюме frontend-разработчика Artem Khloptsev.",
    },
    contact: {
      title: "Контакты — Artem Khloptsev",
      description: "Связаться с frontend-разработчиком Artem Khloptsev по вопросам сайтов, React-интерфейсов и продуктов.",
    },
  },
};
